export enum DietStatus {
    RequestedByNurse = 1,
    ApprovedByDietitian,
    SentToSupervisior,
    DeliverBySupervisior,
    ReceivedByDietitian
}
